module.exports = __webpack_public_path__ + "static/img/10013.06faccb1.png";